var _circle, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginDesktopBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1700 1700",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8,
    cx: 908.5,
    cy: 256.5,
    r: 621.5,
    className: "primaryMedium"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 131,
    cy: 524.5,
    rx: 738,
    ry: 738.5,
    className: "primaryMedium"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginDesktopBackground);
export default __webpack_public_path__ + "static/media/LoginDesktopBackground.86b317e0.svg";
export { ForwardRef as ReactComponent };